import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=ffe3952e&scoped=true";
import script from "./OpenApp.vue?vue&type=script&lang=js";
export * from "./OpenApp.vue?vue&type=script&lang=js";
import style0 from "./OpenApp.vue?vue&type=style&index=0&id=ffe3952e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "ffe3952e", null);
export default component.exports;